import { render } from "./App.vue?vue&type=template&id=68f1cee9"
const script = {}

import "./App.vue?vue&type=style&index=0&id=68f1cee9&lang=css"
script.render = render

export default script